export default function (VirtualKeyboard) {
    return VirtualKeyboard.addLayout({
        code: 'KN-IN',
        name: 'Kannada',
        normal: 'ೊ1234567890-ೃೌೈಾೀೂಬಹಗದಜಡೋೇ್ಿುಪರಕತಚಟೆಂಮನವಲಸ,.ಯ',
        shift: { 0: 'ಒ', 3: '್ರರ್ಜ್ಞತ್ರಕ್ಷಶ್ರ()ಃಋ', 14: 'ಔಐಆಈಊಭಙಘಧಝಢಞಓಏಅಇಉಫಱಖಥಛಠಎ', 39: 'ಣ', 42: 'ಳಶಷ|' },
        alt: { 1: '೧೨೩೪೫೬೭೮೯೦', 12: 'ೄ', 15: 'ೖ', 27: 'ೕ' },
        shift_alt: { 12: 'ೠ', 17: 'ೡ', 29: 'ಌ', 31: 'ೞ' }
    })
}
